var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuToggleVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    viewBox: "0 0 5 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82336 10C3.37565 10 3.82336 9.55228 3.82336 9C3.82336 8.44772 3.37565 8 2.82336 8C2.27108 8 1.82336 8.44772 1.82336 9C1.82336 9.55228 2.27108 10 2.82336 10Z",
    stroke: "#3C4549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82336 3C3.37565 3 3.82336 2.55228 3.82336 2C3.82336 1.44772 3.37565 1 2.82336 1C2.27108 1 1.82336 1.44772 1.82336 2C1.82336 2.55228 2.27108 3 2.82336 3Z",
    stroke: "#3C4549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82336 17C3.37565 17 3.82336 16.5523 3.82336 16C3.82336 15.4477 3.37565 15 2.82336 15C2.27108 15 1.82336 15.4477 1.82336 16C1.82336 16.5523 2.27108 17 2.82336 17Z",
    stroke: "#3C4549",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggleVertical);
export default __webpack_public_path__ + "static/media/menuToggleVertical.daf3ea36cf585959930995cf53309dae.svg";
export { ForwardRef as ReactComponent };